import service from './service';

export class FileService {
    uploadFileToServer(data,guId,basic){
        return service.getRestClient(guId,basic).post('', data);
    }
}